






import { Component, Vue } from 'vue-property-decorator'
import Scene from '@/components/Scene.vue'
import ScoreBoard from '@/components/ScoreBoard.vue'

@Component({ name: 'Layout', components: { Scene, ScoreBoard } })
export default class MyComponent extends Vue {}
